module.exports = __webpack_public_path__ + "static/media/JusticeAndPeace2019.54dabab9.png";